import React from "react";
import AppRoutes from "./routes";
import "./assets/style.scss";


function App() {
  return (
    <div className="App">
    <AppRoutes />
    </div>
  );
}

export default App;

